import { render, staticRenderFns } from "./Situation.vue?vue&type=template&id=655a951b&scoped=true"
import script from "./Situation.vue?vue&type=script&lang=js"
export * from "./Situation.vue?vue&type=script&lang=js"
import style0 from "./Situation.vue?vue&type=style&index=0&id=655a951b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a951b",
  null
  
)

export default component.exports